import React, { useMemo } from "react";
import { Form } from "react-bootstrap";
import Moment from "react-moment";

const SitePilotIntegrationActivity = () => {
  const activityLogs = [
    {
      _id: "685fe349e3572b7f40c4253a",
      uniqueId: "4159063841",
      activityBy: "fgifa9202089",
      client: "studyeventformschema",
      activities: "Schema Name have been successfully added to the Schema.",
      updatedValue: "Schema001",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:42:49.480Z",
      updatedAt: "2025-06-28T12:42:49.480Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe349e3572b7f40c4253b",
      uniqueId: "4159063841",
      activityBy: "fgifa9202089",
      client: "studyeventformschema",
      activities: "Assign Date have been successfully added to the Schema.",
      updatedValue: "2025-06-18",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:42:49.480Z",
      updatedAt: "2025-06-28T12:42:49.480Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe38ce3572b7f40c42594",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      client: "eventMetadata",
      activities:
        "Column Label has been successfully added to the event metadata.",
      updatedValue: "Event Number",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe38ce3572b7f40c42595",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      client: "eventMetadata",
      activities:
        "Column Name has been successfully added to the event metadata.",
      updatedValue: "EVENNUM",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe38ce3572b7f40c42596",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      client: "eventMetadata",
      activities:
        "Column Type has been successfully added to the event metadata.",
      updatedValue: "text",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe39ae3572b7f40c4259b",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      client: "eventMetadata",
      activities:
        "Column Label has been successfully added to the event metadata.",
      updatedValue: "Event Name",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe39ae3572b7f40c4259c",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      client: "eventMetadata",
      activities:
        "Column Name has been successfully added to the event metadata.",
      updatedValue: "EVENTNAM",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe39ae3572b7f40c4259d",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      client: "eventMetadata",
      activities:
        "Column Type has been successfully added to the event metadata.",
      updatedValue: "text",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe3b0e3572b7f40c425b2",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Id have been successfully added.",
      updatedValue: "V0_SCR",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe3b0e3572b7f40c425b3",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Label have been successfully added.",
      updatedValue: "Screening",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe3b0e3572b7f40c425b4",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Day have been successfully added.",
      updatedValue: "-30",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe3b0e3572b7f40c425b5",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Name have been successfully added.",
      updatedValue: "Screening",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe3b1e3572b7f40c425c2",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Id have been successfully added.",
      updatedValue: "V1_D0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe3b1e3572b7f40c425c3",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Label have been successfully added.",
      updatedValue: "Visit 1 Day 0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan",
    },
    {
      _id: "685fe3b1e3572b7f40c425c4",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Day have been successfully added.",
      updatedValue: "0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan",
    },
  ];

  const ClientActivity = useMemo(() => {
    const grouped = {};

    activityLogs.forEach((item) => {
      const date = new Date(item.createdAt).toISOString().split("T")[0];
      if (!grouped[date]) grouped[date] = [];

      grouped[date].push({
        module: item.client || "Unknown Module",
        type: item.actionType || "Unknown Type",
        activities: item.activities,
        prevoiusValue: item.prevoiusValue,
        updatedValue: item.updatedValue,
        activityByName: item.fullName,
        createdAt: item.createdAt,
      });
    });

    return Object.entries(grouped)
      .map(([date, data]) => ({
        date,
        data: data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        ),
      }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [activityLogs]);

  return (
    <>
      <div
        className="p-2 bg-light overflow-auto"
        style={{ height: "calc(100vh - 123px)" }}
      >
        {ClientActivity.map(({ data }, index) => (
          <div key={index}>
            {data?.map((item, key) => (
              <div key={key} className="activity__section">
                <div className="w-100">
                  <p style={{ fontSize: 12 }} className="m-0">
                    Previous Value : {item?.previousValue}
                  </p>
                  <p style={{ fontSize: 12 }} className="mb-1">
                    Updated Value : {item?.updatedValue}
                  </p>
                  <ul className="m-0 p-0">
                    <li>
                      <p className="m-0 text-muted" style={{ fontSize: 12 }}>
                        <span
                          className="text-capitalize"
                          style={{ fontWeight: 600 }}
                        >
                          {item.type}
                          {": "}
                        </span>
                        {item.activities}
                      </p>
                    </li>
                  </ul>
                  <div className="mt-1 d-flex justify-content-between">
                    <Form.Label
                      className="m-0 text-muted"
                      style={{ fontSize: 12 }}
                    >
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.createdAt}
                      </Moment>
                    </Form.Label>
                    <Form.Label
                      className="m-0 text-muted"
                      style={{ fontSize: 12 }}
                    >
                      By: {item?.activityByName}
                    </Form.Label>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default SitePilotIntegrationActivity;
